import React from 'react';
import {NavLink} from 'react-router-dom';
import {useIntl} from 'react-intl';


import * as styleUtils from '../../../../utils/styleUtils';

import {assetUrl} from '../../../../utils/cdnUtils';
import {staticConstants} from '../../../modules/Static';
import {useIsAuthenticated} from '../../../contexts/Auth';

import MainNavigation from '../../../global/MainNavigation';
import MetaNavigation from '../../../global/MetaNavigation';

import styles from './Header.scss';


export default function Header() {

    const {formatMessage} = useIntl();
    const isAuthenticated = useIsAuthenticated();

    return (
        <header className={styles.pageHeader}>
            <div className={styleUtils.toClasses('row', 'container')}>

                <div className={styles.logoHeader}>
                    <NavLink
                        aria-current={'page'}
                        aria-label={formatMessage({id: 'main.nav.home.label'})}
                        to={staticConstants.NAV_HOME}
                    >
                        <img
                            alt={''}
                            className={styles.logo}
                            height={'23.93'}
                            src={assetUrl('/images/logo.svg')}
                            width={'111.68'}
                        />
                    </NavLink>
                </div>

                <MainNavigation>

                    {isAuthenticated && <MetaNavigation/>}

                </MainNavigation>

            </div>
        </header>
    );
}
